module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDE4IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTE0LjUxNiA1LjAxOUMxMi42NyAxLjg3NiAxMC40OTYgMCA4LjcwMyAwYy0xLjgxIDAtMy45OSAxLjg3Ni01LjgzIDUuMDJDMS4wNzQgOC4wOSAwIDExLjY1OSAwIDE0LjU2NWMwIDIuOTcuODgyIDUuNDIgMi41NSA3LjA4M0M0LjA5MiAyMy4xODcgNi4yMiAyNCA4LjcwMiAyNGMyLjQ4MiAwIDQuNjEtLjgxMyA2LjE1My0yLjM1MiAxLjY2OC0xLjY2MyAyLjU1LTQuMTEzIDIuNTUtNy4wODMgMC0yLjktMS4wOC02LjQ2OC0yLjg5LTkuNTQ2eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite-page/egg.svg
// module id = Rj9l
// module chunks = 1